function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $08bf99cbf4922eec$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"dar2o":"myspace.04f7c78e.js","jOhXA":"chevron-right.8856609f.svg","1INq0":"pattern.41e4058b.css","j6GAN":"youshouldnotbehere.f0aefe0e.js"}'));



var $4zpiX = parcelRequire("4zpiX");
var $f7b98b6135b25f39$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else $f7b98b6135b25f39$exports = factory();
})($f7b98b6135b25f39$exports, function() {
    var payloads = function(tag, start) {
        if (!start) start = 0;
        var length = tag.length;
        return pipeSplit(tag.substr(start, length - start));
    };
    var pipeSplit = function(payload) {
        return payload.split("|");
    };
    var tag = function(tag, attributes, payload) {
        if (!payload) {
            payload = attributes;
            attributes = {};
        }
        var html = "<".concat(tag);
        for(var attribute in attributes)if (attributes.hasOwnProperty(attribute)) html = html.concat(" ", attribute, '="', attributes[attribute], '"');
        return html.concat(">", payload, "</", tag, ">");
    };
    var matchTag = function(match) {
        var action = match[1].substr(0, 1), p;
        switch(action){
            case "!":
                return tag("span", {
                    class: "slack-cmd"
                }, payloads(match[1], 1)[0]);
            case "#":
                p = payloads(match[1], 2);
                return tag("span", {
                    class: "slack-channel"
                }, p.length == 1 ? p[0] : p[1]);
            case "@":
                p = payloads(match[1], 2);
                return tag("span", {
                    class: "slack-user"
                }, p.length == 1 ? p[0] : p[1]);
            default:
                p = payloads(match[1]);
                return tag("a", {
                    href: p[0]
                }, p.length == 1 ? p[0] : p[1]);
        }
    };
    var matchBold = function(match) {
        return safeMatch(match, tag("strong", payloads(match[1])));
    };
    var matchItalic = function(match) {
        return safeMatch(match, tag("em", payloads(match[1])));
    };
    var matchFixed = function(match) {
        return safeMatch(match, tag("code", payloads(match[1])));
    };
    var isWhiteSpace = function(input) {
        return /^\s?$/.test(input);
    };
    var safeMatch = function(match, tag) {
        var prefix_ok = match.index == 0;
        var postfix_ok = match.index == match.input.length - match[0].length;
        if (!prefix_ok) {
            var charAtLeft = match.input.substr(match.index - 1, 1);
            prefix_ok = isWhiteSpace(charAtLeft);
        }
        if (!postfix_ok) {
            var charAtRight = match.input.substr(match.index + match[0].length, 1);
            postfix_ok = isWhiteSpace(charAtRight);
        }
        if (prefix_ok && postfix_ok) return tag;
        return false;
    };
    var publicParse = function(text) {
        if (typeof text === "string") {
            var patterns = [
                {
                    p: /<(.*?)>/g,
                    cb: matchTag
                },
                {
                    p: /\*([^\*]*?)\*/g,
                    cb: matchBold
                },
                {
                    p: /_([^_]*?)_/g,
                    cb: matchItalic
                },
                {
                    p: /`([^`]*?)`/g,
                    cb: matchFixed
                }
            ];
            for(var p = 0; p < patterns.length; p++){
                var pattern = patterns[p], original = text, result;
                while((result = pattern.p.exec(original)) !== null){
                    var replace = pattern.cb(result);
                    if (replace) text = text.replace(result[0], replace);
                }
            }
        }
        return text;
    };
    return {
        parse: publicParse
    };
});


// This sets up the parse server 
const $2d0009ff71ea570f$var$STORAGE_ROOT = "fnsz_app_last_";
const $2d0009ff71ea570f$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $2d0009ff71ea570f$var$PEVENTS_ENDPOINT = "getPersonalEvents";
const $2d0009ff71ea570f$var$CEVENTS_ENDPOINT = "getCompanyEvents";
const $2d0009ff71ea570f$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $2d0009ff71ea570f$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
const $2d0009ff71ea570f$var$REST_API_KEY = "fabjEVYWZCwtBWXZ62BF3oAjU7ZzipumKecJidKJ";
$4zpiX.initialize($2d0009ff71ea570f$var$APP_ID, $2d0009ff71ea570f$var$JAVASCRIPT_KEY);
$4zpiX.serverURL = $2d0009ff71ea570f$var$SERVER_URL;
var $2d0009ff71ea570f$var$funsizer, $2d0009ff71ea570f$var$srch, $2d0009ff71ea570f$var$srchContainer, $2d0009ff71ea570f$var$resourceContainer, $2d0009ff71ea570f$var$peepInfo, $2d0009ff71ea570f$var$modal;
var $2d0009ff71ea570f$var$funsizerLoaded = false;
var $2d0009ff71ea570f$var$docsLoaded = false;
var $2d0009ff71ea570f$var$remindersLoaded = false;
window.addEventListener("load", ()=>{
    gsap.to(document.getElementsByClassName("loader-container")[0], {
        opacity: 1,
        duration: 0.25
    });
    gsap.to(document.getElementsByClassName("loader")[0], {
        scale: 0.5,
        duration: 1,
        ease: "bounce.out",
        repeat: -1,
        yoyo: true
    });
    $2d0009ff71ea570f$var$resourceContainer = document.getElementById("resources_data");
    $2d0009ff71ea570f$var$srchContainer = document.getElementById("resources_search");
    $2d0009ff71ea570f$var$srch = document.getElementById("search_field");
    $2d0009ff71ea570f$var$srch.addEventListener("keyup", ()=>{
        $2d0009ff71ea570f$var$doSearch();
    });
    document.getElementById("btn_search_cancel").addEventListener("click", ()=>{
        document.getElementById("resources_header").style.display = "flex";
        $2d0009ff71ea570f$var$srchContainer.style.display = "none";
        $2d0009ff71ea570f$var$srch.value = "";
        $2d0009ff71ea570f$var$doSearch();
    });
    document.getElementById("btn_logout").addEventListener("click", ()=>{
        $4zpiX.User.logOut().then(()=>{
            $2d0009ff71ea570f$var$initFunsizer();
        });
    });
    document.getElementById("btn_search").addEventListener("click", ()=>{
        document.getElementById("resources_header").style.display = "none";
        $2d0009ff71ea570f$var$srchContainer.style.display = "flex";
        $2d0009ff71ea570f$var$srch.focus();
    });
    document.getElementById("file-input").addEventListener("change", (event)=>{
        console.log("change");
        const file = event.target.files[0];
        const src = URL.createObjectURL(file);
        document.getElementById("myspace-current-image").style.backgroundImage = `url(${src})`;
    });
    $2d0009ff71ea570f$var$initFunsizer();
    const hiddens = document.querySelector("nav").getElementsByClassName("hidden");
    for(var i = 0; i < hiddens.length; i++)gsap.to(hiddens[i], {
        opacity: 1,
        duration: 0.35,
        delay: 0.2 * i
    });
    $2d0009ff71ea570f$var$modal = document.querySelector(".modal-wrapper");
    document.getElementById("modal-close-btn").addEventListener("click", ()=>{
        $2d0009ff71ea570f$var$modal.style.display = "none";
    });
    document.getElementById("myspace-user-save").addEventListener("click", ()=>{
        $2d0009ff71ea570f$var$savePeepEdit();
    });
});
const $2d0009ff71ea570f$var$initFunsizer = ()=>{
    $2d0009ff71ea570f$var$funsizer = $4zpiX.User.current();
    if ($2d0009ff71ea570f$var$funsizer) {
        $2d0009ff71ea570f$var$getFunsizerInfo().then((info)=>{
            $2d0009ff71ea570f$var$peepInfo = info;
            const outerContainer = document.getElementById("funsizer");
            const perp = document.createElement("div");
            perp.classList.add("myspace-user-info");
            outerContainer.prepend(perp);
            perp.addEventListener("click", ()=>{
                $2d0009ff71ea570f$var$showEditModal();
            });
            const userImage = document.createElement("img");
            userImage.classList.add("profile-photo");
            userImage.setAttribute("id", "user_image");
            userImage.setAttribute("alt", "Portrait image of the logged in Funsizer");
            userImage.src = info.imageURL;
            perp.append(userImage);
            const userInfo = document.createElement("div");
            userInfo.classList.add("info");
            perp.append(userInfo);
            const userName = document.createElement("p");
            userName.innerHTML = info.name;
            userName.classList.add("name");
            userInfo.append(userName);
            const userRole = document.createElement("p");
            userRole.innerHTML = info.role;
            userInfo.append(userRole);
            const userSince = document.createElement("p");
            const d = new Date(info.since);
            userSince.innerHTML = `Since ${d.getUTCFullYear()}`;
            userSince.classList.add("year");
            userInfo.appendChild(userSince);
            $2d0009ff71ea570f$var$funsizerLoaded = true;
            $2d0009ff71ea570f$var$showUI();
        }).catch(function(e) {
            $2d0009ff71ea570f$var$handleParseError("Error when fetching User Info", e);
        });
        $2d0009ff71ea570f$var$getImportantLinks().then((links)=>{
            $2d0009ff71ea570f$var$renderImportantLinks(links);
        }).catch(function(e) {
            $2d0009ff71ea570f$var$handleParseError("Error when fetching Important Links", e);
        });
        $2d0009ff71ea570f$var$getReminders().then((reminders)=>{
            $2d0009ff71ea570f$var$renderReminders(reminders);
        }).catch(function(e) {
            $2d0009ff71ea570f$var$handleParseError("Error when fetching Reminders", e);
        });
        $2d0009ff71ea570f$var$initTimeZones();
    } else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
};
const $2d0009ff71ea570f$var$showEditModal = ()=>{
    $2d0009ff71ea570f$var$modal.style.display = "flex";
    document.getElementById("myspace-current-image").style.backgroundImage = `url(${$2d0009ff71ea570f$var$peepInfo.imageURL})`;
    document.getElementById("myspace-name").value = $2d0009ff71ea570f$var$peepInfo.name;
    document.getElementById("myspace-role").value = $2d0009ff71ea570f$var$peepInfo.role;
    document.getElementById("myspace-current-image").addEventListener("click", ()=>{
        document.getElementById("file-input").click();
    });
};
const $2d0009ff71ea570f$var$savePeepEdit = ()=>{
    const fInput = document.getElementById("file-input");
    var parseFile;
    var maxAllowedSize = 3145728; // 3 MB in bytes
    if (fInput.files.length > 0 && fInput.files[0].size > maxAllowedSize) {
        alert("\uD83C\uDFB5 You're so vain. \uD83C\uDFB5 Plz limit your profile image to 3MB.");
        return;
    }
    if (document.getElementById("myspace-name").value.length < 1) {
        alert("\uD83E\uDD14 What's your name?");
        return;
    }
    if (document.getElementById("myspace-role").value.length < 1) {
        alert("\uD83E\uDD14 What do you do at Funsize?");
        return;
    }
    if (fInput.files.length > 0) {
        const file = fInput.files[0];
        const name = fInput.files[0].name;
        parseFile = new $4zpiX.File(name, file);
    }
    if (parseFile) parseFile.save().then(()=>{
        $2d0009ff71ea570f$var$savePeepCore(parseFile);
    }, function(error) {
        window.alert("Error while saving peep image", error);
    });
    else $2d0009ff71ea570f$var$savePeepCore();
};
const $2d0009ff71ea570f$var$savePeepCore = (i)=>{
    const Player = $4zpiX.Object.extend("Player");
    const p = new Player();
    p.set("objectId", $2d0009ff71ea570f$var$peepInfo.id);
    p.set("Name", document.getElementById("myspace-name").value);
    p.set("Role", document.getElementById("myspace-role").value);
    if (i) p.set("ProfileImage", i);
    p.save().then((r)=>{
        $2d0009ff71ea570f$var$modal.style.display = "none";
        $2d0009ff71ea570f$var$peepInfo.name = r.get("Name");
        $2d0009ff71ea570f$var$peepInfo.role = r.get("Role");
        $2d0009ff71ea570f$var$peepInfo.imageURL = r.get("ProfileImage").url();
        localStorage.setObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}funsizer_info`, $2d0009ff71ea570f$var$peepInfo);
        const outerContainer = document.getElementById("funsizer").childNodes[0];
        outerContainer.childNodes[0].src = $2d0009ff71ea570f$var$peepInfo.imageURL;
        outerContainer.childNodes[1].childNodes[0].innerHTML = $2d0009ff71ea570f$var$peepInfo.name;
        outerContainer.childNodes[1].childNodes[1].innerHTML = $2d0009ff71ea570f$var$peepInfo.role;
    }, (error)=>{
        alert("Failed updating peep info: " + error);
    });
};
const $2d0009ff71ea570f$var$showUI = ()=>{
    if ($2d0009ff71ea570f$var$funsizerLoaded && $2d0009ff71ea570f$var$docsLoaded && $2d0009ff71ea570f$var$remindersLoaded) {
        gsap.to(document.getElementsByClassName("loader-container")[0], {
            opacity: 0,
            duration: 0.25
        });
        const hiddens = document.getElementsByClassName("hidden");
        for(var i = 0; i < hiddens.length; i++)gsap.to(hiddens[i], {
            opacity: 1,
            duration: 0.35,
            delay: 0.2 * i
        });
    }
};
const $2d0009ff71ea570f$var$doSearch = ()=>{
    let search = $2d0009ff71ea570f$var$srch.value.toLowerCase();
    for(var i = 0; i < $2d0009ff71ea570f$var$resourceContainer.childNodes.length; i++){
        let item = $2d0009ff71ea570f$var$resourceContainer.childNodes[i].childNodes[0].innerHTML.toLowerCase();
        if (item.indexOf(search) == -1) $2d0009ff71ea570f$var$resourceContainer.childNodes[i].style.display = "none";
        else $2d0009ff71ea570f$var$resourceContainer.childNodes[i].style.display = "block";
    }
};
/**
  * Important Links Calls
  */ async function $2d0009ff71ea570f$var$getImportantLinks() {
    if (!$2d0009ff71ea570f$var$shouldLoadImportantLinksFromAPI()) // console.log('retreiving existing links from storage');
    return localStorage.getObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}links_data`);
    try {
        // console.log('retreiving fresh links from api');
        const links = await $4zpiX.Cloud.run("importantLinks");
        const d = new Date();
        const day = d.getDay();
        localStorage.setObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}links_load`, day);
        localStorage.setObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}links_data`, links);
        return localStorage.getObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}links_data`);
    } catch (error) {
        throw error;
    }
}
const $2d0009ff71ea570f$var$shouldLoadImportantLinksFromAPI = ()=>{
    const d = new Date();
    const day = d.getDay();
    const lastDay = localStorage.getObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}links_load`);
    const data = localStorage.getObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}links_data`);
    if (lastDay == null || data == null) {
        localStorage.setObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}links_load`, day);
        return true;
    }
    return day != lastDay; // only refresh if a new day
};
var $ead137b16b1744a7$exports = {};

$ead137b16b1744a7$exports = new URL((parcelRequire("kyEFX")).resolve("jOhXA"), import.meta.url).toString();


const $2d0009ff71ea570f$var$renderImportantLinks = (links)=>{
    $2d0009ff71ea570f$var$docsLoaded = true;
    $2d0009ff71ea570f$var$showUI();
    if (links.length == 0) //TODO: render empty state 
    return;
    $2d0009ff71ea570f$var$resourceContainer.innerHTML = "";
    for(var i = 0; i < links.length; i++){
        //TODO: Make this whole thing an anchor and the container a div
        const l = document.createElement("li");
        $2d0009ff71ea570f$var$resourceContainer.appendChild(l);
        const a = document.createElement("a");
        l.appendChild(a);
        a.innerHTML = links[i].Title;
        a.href = links[i].URL;
        a.target = "_blank";
        const img = document.createElement("img");
        a.appendChild(img);
        const url = new URL($ead137b16b1744a7$exports);
        img.src = url;
    }
};
/**
 * Reminders Calls
 */ const $2d0009ff71ea570f$var$reminderTimer = 5; //every 5 minutes
var $2d0009ff71ea570f$var$currentReminderTimer = 0;
async function $2d0009ff71ea570f$var$getReminders() {
    const FunsizeAppMention = $4zpiX.Object.extend("FunsizeAppMention");
    const query = new $4zpiX.Query(FunsizeAppMention);
    query.descending("createdAt");
    try {
        const reminders = await query.find();
        return reminders;
    } catch (error) {
        throw error;
    }
}
const $2d0009ff71ea570f$var$renderReminders = (reminders)=>{
    $2d0009ff71ea570f$var$remindersLoaded = true;
    $2d0009ff71ea570f$var$showUI();
    const messageList = document.getElementById("message-list");
    messageList.innerHTML = "";
    for(var i = 0; i < reminders.length; i++){
        const s = $f7b98b6135b25f39$exports.parse(reminders[i].get("message")).replace('<span class="slack-user">03UWU5RDA9</span>', "");
        const li = document.createElement("li");
        const meta = document.createElement("div");
        const postAuthor = document.createElement("p");
        const postDate = document.createElement("p");
        const postTime = document.createElement("p");
        const message = document.createElement("p");
        meta.classList.add("metadata");
        message.classList.add("slack-message");
        const d = new Date(reminders[i].get("postDate"));
        const dh = d.getHours();
        var minutes = d.getMinutes();
        minutes = minutes < 10 ? "0" + minutes : minutes;
        postAuthor.innerHTML = reminders[i].get("name");
        postDate.innerHTML = `${d.toLocaleString("en-US", {
            month: "short"
        })} ${d.getDate()}`;
        postTime.innerHTML = `${dh > 12 ? dh - 12 : dh}:${minutes}${dh >= 12 ? "PM" : "AM"}`;
        message.innerHTML = s;
        messageList.append(li);
        li.append(meta, message);
        meta.append(postAuthor, postDate, postTime);
    }
};
/**
 * User info call
 */ async function $2d0009ff71ea570f$var$getFunsizerInfo() {
    const info = localStorage.getObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}funsizer_info`);
    if (!info || !info.id) {
        const query = new $4zpiX.Query("Player");
        query.equalTo("Email", $2d0009ff71ea570f$var$funsizer.get("email"));
        query.select("Name", "Email", "Role", "StartDate", "ProfileImage");
        try {
            // console.log(query)
            var p = await query.find();
            p = p[0];
            // console.log(p)
            const peep = new Object();
            peep.id = p.id;
            peep.name = p.get("Name");
            peep.role = p.get("Role");
            peep.since = p.get("StartDate");
            peep.imageURL = p.get("ProfileImage") ? p.get("ProfileImage").url() : "./resources/unknown.png";
            localStorage.setObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}funsizer_info`, peep);
            return localStorage.getObject(`${$2d0009ff71ea570f$var$STORAGE_ROOT}funsizer_info`);
        } catch (error) {
            throw error;
        }
    }
    return info;
}
/**
 * Timezone calls
 */ const $2d0009ff71ea570f$var$initTimeZones = ()=>{
    const current = new Date();
    $2d0009ff71ea570f$var$setTime();
    setInterval(()=>{
        $2d0009ff71ea570f$var$setTime();
        $2d0009ff71ea570f$var$currentReminderTimer++;
        if ($2d0009ff71ea570f$var$currentReminderTimer >= $2d0009ff71ea570f$var$reminderTimer) {
            // console.log('setting reminders')
            $2d0009ff71ea570f$var$currentReminderTimer = 0;
            $2d0009ff71ea570f$var$getReminders().then((reminders)=>{
                $2d0009ff71ea570f$var$renderReminders(reminders);
            }).catch(function(e) {
                $2d0009ff71ea570f$var$handleParseError("Error when fetching Reminders", e);
            });
        }
    }, 60000);
};
const $2d0009ff71ea570f$var$setTime = ()=>{
    const current = new Date();
    var minutes = current.getUTCMinutes();
    minutes = minutes < 10 ? "0" + minutes : minutes;
    const est = new Date(current.toLocaleString("en-US", {
        timeZone: "America/Detroit"
    })).getHours();
    const cst = new Date(current.toLocaleString("en-US", {
        timeZone: "America/Chicago"
    })).getHours();
    const isl = new Date(current.toLocaleString("en-US", {
        timeZone: "Iceland"
    })).getHours();
    const pst = new Date(current.toLocaleString("en-US", {
        timeZone: "America/Los_Angeles"
    })).getHours();
    document.getElementById("pst").innerHTML = `${pst > 12 ? pst - 12 : pst}:${minutes}${pst >= 12 ? "PM" : "AM"}`;
    document.getElementById("isl").innerHTML = `${isl > 12 ? isl - 12 : isl}:${minutes}${isl >= 12 ? "PM" : "AM"}`;
    document.getElementById("cst").innerHTML = `${cst > 12 ? cst - 12 : cst}:${minutes}${cst >= 12 ? "PM" : "AM"}`;
    document.getElementById("est").innerHTML = `${est > 12 ? est - 12 : est}:${minutes}${est >= 12 ? "PM" : "AM"}`;
};
function $2d0009ff71ea570f$var$handleParseError(msg, err) {
    switch(err.code){
        case $4zpiX.Error.INVALID_SESSION_TOKEN:
            alert("Invalid session token.");
            $4zpiX.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}
Storage.prototype.setObject = function(key, value) {
    this.setItem(key, JSON.stringify(value));
};
Storage.prototype.getObject = function(key) {
    var value = this.getItem(key);
    return value && JSON.parse(value);
};


//# sourceMappingURL=myspace.04f7c78e.js.map
